import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Card, CardHeader, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton, Chip } from '@mui/material';
import axios from 'src/utils/axios';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Skeleton from '@mui/material/Skeleton';
import { useLocation } from 'react-router';

function IndividualInquiryReceipts() {
    const navigate = useNavigate();
    const location = useLocation();

    const { UYear, UPeriod, ModelCode, SerialNo } = useParams();

    const [generalData, setGeneralData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);

    useEffect(() => {
        sendInformationsOfProduct();
    }, []);

    const sendInformationsOfProduct = () => {
        const data = {
            ModelCode: ModelCode,
            SerialNumber: Number(SerialNo),
            Year: Number(UYear),
            Month: Number(UPeriod)
        }

        axios.get(`GetReceiptsOfIndividualProduct/${data.ModelCode}/${data.SerialNumber}/${data.Year}/${data.Month}`)
            .then((response) => {
                var data = response.data;
                setGeneralData(Array.isArray(data) ? data : []);
                setPage(0);
                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const handleRowClick = (ReceiptNumber) => {
        navigate(`/SarisQueries/ReceiptDetails/${ReceiptNumber}`);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleGoBack = () => {
        const fullPath = location.pathname;
        const basePath = fullPath.split('/').slice(0, 2).join('/');
        // localStorage.setItem('previousPath', basePath || '/');
        // navigate(-1);

        // Detay sayfasından dönüldüğünü belirtmek için previousPath'i güncelliyoruz.
        localStorage.setItem('previousPath', basePath || '/');
        navigate(-1); // Geri gitmek için useNavigate hook'unu kullanıyoruz.

    }

    return (
        <Container maxWidth="lg" sx={{ py: 3 }}>
            <Card>
                <CardHeader
                    avatar={
                        <IconButton onClick={() => { handleGoBack(); }} size="small">
                            <ArrowBackIcon />
                        </IconButton>
                    }
                    title="Fişler"
                />
                <Divider />
                <TableContainer>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Fiş Numarası</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Servis Kodu</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Hizmet</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Durum</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Tarih</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                Array.from(new Array(3)).map((_, index) => (
                                    <TableRow key={index}>
                                        {Array.from(new Array(5)).map((_, cellIndex) => (
                                            <TableCell key={cellIndex} colSpan={1}>
                                                <Skeleton animation="pulse" variant="text" width={150} />
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                generalData.length > 0 && generalData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Chip
                                                label={item.FIS_NO}
                                                size="small"
                                                variant="outlined"
                                                clickable
                                                onClick={() => { handleRowClick(item.FIS_NO); }}
                                            />
                                        </TableCell>
                                        <TableCell>{item.SERVIS_KODU}</TableCell>
                                        <TableCell>{item.HIZMET}</TableCell>
                                        <TableCell>{item.DURUM}</TableCell>
                                        <TableCell>{moment(item.TARIH).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[15, 25, 50, 100, 250]}
                        component="div"
                        count={generalData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </Card>
        </Container>
    );
}

export default IndividualInquiryReceipts;
